import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, BookOpen, Scale, HeartHandshake } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
export function ActivitiesSection() {
  const activities = [{
    icon: <BarChart3 size={32} data-id="element-29" />,
    title: 'Research & Analytics',
    description: 'Conducting comprehensive research on gambling behavior, market trends, and policy impact studies to inform decision-making.'
  }, {
    icon: <BookOpen size={32} data-id="element-30" />,
    title: 'Education & Awareness',
    description: 'Running educational programs and campaigns to raise awareness about responsible gambling for players and communities.'
  }, {
    icon: <Scale size={32} data-id="element-31" />,
    title: 'Advocacy & Policy',
    description: 'Collaborating with regulators and lawmakers to develop fair, transparent, and effective gambling legislation.'
  }, {
    icon: <HeartHandshake size={32} data-id="element-32" />,
    title: 'Player Support',
    description: 'Providing counseling resources, helplines, and direct support systems for individuals and families affected by gambling addiction.'
  }];
  return <section id="activities" className="py-20 bg-white" data-id="element-33">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-34">
        <SectionHeading title="Our Activities" subtitle="Comprehensive approaches to building a safer gaming environment." data-id="element-35" />

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-36">
          {activities.map((activity, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group p-8 rounded-xl bg-white border border-gray-100 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2" data-id="element-37">
              <div className="w-14 h-14 rounded-full bg-[#0f5f5f]/5 text-[#0f5f5f] flex items-center justify-center mb-6 group-hover:bg-[#0f5f5f] group-hover:text-[#d4a74a] transition-colors duration-300" data-id="element-38">
                {activity.icon}
              </div>
              <h3 className="text-xl font-serif font-bold text-gray-900 mb-4 group-hover:text-[#0f5f5f] transition-colors" data-id="element-39">
                {activity.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-40">
                {activity.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}